export const iconPosition = (type) => {
  const iconsPosition = {
    rewards: '0 -48px',
    locations: '-24px -48px',
    locationsGrey: '-24px 0',
    locationsGreySmall: '-80px -72px',
    moreInfo: '-48px -48px',
    info: '-384px -24px',
    blackInfo: '-384px 0px',
    delete: '-356px 0px',
    themeInfo: '-384px -48px',
    outlinedBlackInfo: '-407px 1px',
    back: '-216px 0px',
    backWhite: '-216px -24px',
    chevronRightBlack: '-144px 0px',
    chevronRightWhite: '-144px -24px',
    chevronUpWhite: '-96px -24px',
    chevronDown: '-96px 0px',
    chevronDownSmall: '-128px -72px',
    chevronDownSmallWhite: '-144px -72px',
    share: '-506px 0px',
    edit: '-430px 0px',
    lock: '-527px 0px',
    gift: '0px -24px',
    giftBrown: '0px -48px',
    giftSmall: '-63px -88px',
    giftSmallBlack: '-63px -72px',
    giftSmallBrown: '-63px -104px',
    emptyRewards: '-360px -144px',
    lockIcon: '-16px -72px',
    offersCardBackground: '-37px -212px',
    loyaltyCardBG: '-740px -120px',
    loyaltyCardSM: '-1235px -120px',
    emptyResultBG: '-1410px -120px',
    refresh: '-240px -24px',
    refreshBlack: '-240px 0',
    appStoreBtn: '-773px -494px',
    playStoreBtn: '-934px -494px',
    heroBG: '0 -494px',
    birthdayRewardSM: '-375px -496px',
    moreRewardsSM: '-568px -496px',
    earnPointsImage: '-1695px -120px',
    birthdayRewardBG: '-2022px -120px',
    moreRewardsBG: '-2346px -120px',
    birthdayCardImage: '-2671px -119px',
    instagramIcon: '-1610px -120px',
    facebookIcon: '-1650px -120px',
    filterIcon: '-625px 0px',
    expiredIcon: '-2783px -119px',
    redeemIcon: '-2823px -119px',
    filledCrossIcon: '-32px -72px',
    closeIcon: '-312px 0px',
    circularCloseIcon: '-288px 0px',
    closeWhiteIcon: '-312px -24px',
    doubleArrowRight: '-650px -47px',
    welcomeCardImage: '-2864px -119px',
    twitterIcon: '-2975px -120px',
    arrowDown: '-72px 0px',
    arrowDownWhite: '-72px -24px',
    threeDots: '-264px 0px',
    threeDotsWhite: '-264px -24px',
    NON_VEGETARIAN: '-112px -72px',
    VEGETARIAN: '-96px -72px',
    phoneIcon: '-672px 0px',
    checkIcon: '-696px -48px',
    greyCheckIcon: '-696px -24px',
    warningIcon: '-720px -48px',
    cancelledIcon: '-1095px -494px',
    servedIcon: '-1214px -494px',
    hamburgerIcon: '-48px 0px',
    food: '-744px -48px',
    switch: '-768px -48px',
    orders: '-792px -48px',
    login: '-816px -48px',
    account: '-480px -48px',
    loyaltyCardBG2: '-1343px -495px',
    arrowRightTheme: '-144px -48px',
    earnPointsTag: '-94px -104px',
    currencyCoin: '-1332px -494px',
    billIcon: '-1414px -494px',
    currencyCoinSmall: '-1496px -494px',
    anniversaryCardImage: '-2976px -119px',
    anniversaryRewardSM: '-1532px -496px',
    currencyIcon: '-864px -48px',
    receiptIcon: '-888px -48px',
    cakeIcon: '-912px -48px',
    ringIcon: '-936px -48px',
    tierLevelBG1: '46px -793px',
    tierLevelBG2: '-296px -793px',
    tierLevelBG3: '-640px -793px',
    tierLevelIcon1: '0px -983.3px',
    tierLevelIcon2: '-104px -983.3px',
    tierLevelIcon3: '-208px -983.3px',
    brandIconLarge: '-312px -984px',
    brandIconSmall: '-864px -24px',
    brandIconSmallGrey: '-864px 0px',
    outlinedBlackInfoSmall: '-48px -72px',
    anniversaryCardImageV2: '-2983px -130px',
    welcomeCardImageV2: '-2871px -130px',
    birthdayCardImageV2: '-2680px -130px',
  };
  return iconsPosition[type];
};
